import React from 'react'
import "../Assets/styles/blog.css"
import one from "../Assets/images/homepage_Link___blog1_jpg.png"
import two from "../Assets/images/homepage_Link___blog2_jpg.png"
import three from "../Assets/images/homepage_Link___blog3_jpg.png"

const Blog = () => {
  return (
    <>
        <div class="container-lg">
            <div className="header" data-aos="fade-right" data-aos-duration="1000">
                <span>Blog</span> 
                <h3>Our Publications</h3>
            </div>
            {/* <div class="section-title">
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incidiunt labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p>
                <div class="bar"></div>
            </div> */}
            <div class="row">
                <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-duration="1000">
                    <div class="single-blog">
                        <div class="image">
                            <a href="/">
                                <img src={one} className='blog-image' alt="im"/>
                            </a>
                        </div>
                        <div class="content">
                            <span>20 April 2020</span>
                            <h3>
                                <a href="/">Great Tips To Earn More Money From Digital Industry</a>
                            </h3>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor</p>
                            <a class="read-more" href="/">Read More</a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-duration="1000">
                    <div class="single-blog">
                        <div class="image">
                            <a href="/">
                                <img src={two} className='blog-image' alt="im"/>
                            </a>
                        </div>
                        <div class="content">
                            <span>21 April 2020</span>
                            <h3>
                                <a href="/">The Billionaire Guide On Design That will Get You Rich</a>
                            </h3>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor</p>
                            <a class="read-more" href="/">Read More</a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-duration="1000">
                    <div class="single-blog">
                        <div class="image">
                            <a href="/">
                                <img src={three} className='blog-image' alt="im"/>
                            </a>
                        </div>
                        <div class="content">
                            <span>22 April 2020</span>
                            <h3>
                                <a href="/">Making Peace With The Feast Or Famine Of Freelancing</a>
                            </h3>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor</p>
                            <a class="read-more" href="/">Read More</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default Blog